export const PIXEL_EVENT_URL = 'https://cdn.dspretargettraff.com/libs/a.js';

const PIXEL_EVENTS = [
  'visit',
  'regfin',
  'regnotfin',
  'ftd',
  'bet',
  'bet30',
  'deposit',
  'dep2',
  'dep3',
  'dep4',
  'dep5plus',
] as const;

export type PixelEventName = (typeof PIXEL_EVENTS)[number];

export const DEPOSITS_KEYS = ['ftd', 'dep2', 'dep3', 'dep4', 'dep5plus'];

export const PixelEvents: Record<Exclude<PixelEventName, 'bet30'>, string> = {
  visit: '5',
  regfin: '1',
  regnotfin: '14',
  ftd: '2',
  bet: '3',
  deposit: '4',
  dep2: '6',
  dep3: '7',
  dep4: '8',
  dep5plus: '9',
} as const;

export const PixelAudiences: Record<PixelEventName, number> = {
  visit: 80,
  regfin: 81,
  regnotfin: 82,
  ftd: 83,
  bet: 88,
  bet30: 90,
  deposit: 89,
  dep2: 84,
  dep3: 85,
  dep4: 86,
  dep5plus: 87,
} as const;

export type PixelEvent = Exclude<PixelEventName, 'bet30' | 'deposit'>;
